import { useMutation } from '@tanstack/react-query'

import { ErrorResponse } from '@sparkai/utils'

import { apiClient } from '../apiClient'

type ImageMediaResponse = {
  mediaId: string
  ownerId: string
  filename: string
  mimeType: string
  location: string
}

export function useUploadImage(onSuccess?: (data: ImageMediaResponse) => void, onError?: () => void) {
  return useMutation<ImageMediaResponse, ErrorResponse, File>({
    mutationFn: async (file: File) => {
      const formData = new FormData()
      formData.append('file', file)

      const { data } = await apiClient.post<ImageMediaResponse>('/int/v3/media', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 60000,
      })
      return data
    },
    onSuccess: onSuccess,
    onError: onError,
  })
}
